export default defineNuxtPlugin(() => {
  // Intentionally disabled to avoid noisy console output in local and production.
})
